import { memo } from "react";

interface StatBarProps {
  value: number;
  colorClass: string;
  className?: string;
}

const StatBar = memo<StatBarProps>(({ value, colorClass, className = "" }) => (
  <div
    className={`h-[4px] bg-white/10 rounded-full overflow-hidden ${className}`}
  >
    <div
      className={`h-full rounded-full transition-all duration-700 ${colorClass}`}
      style={{ width: `${Math.min(100, Math.max(0, value))}%` }}
    />
  </div>
));

StatBar.displayName = "StatBar";
export default StatBar;
